import type { DividerBlockContent } from "../types"
import { Label } from "@/components/ui/label"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface DividerBlockEditorProps {
  content: DividerBlockContent | null
  onChange: (content: DividerBlockContent) => void
}

export function DividerBlockEditor({ content, onChange }: DividerBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<DividerBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Divider</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Style</Label>
          <Select
            value={c.style ?? "line"}
            onValueChange={(v) =>
              update({ style: v as "line" | "dots" | "thick" })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="line">Line</SelectItem>
              <SelectItem value="dots">Dots</SelectItem>
              <SelectItem value="thick">Thick</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  )
}
